export default __webpack_public_path__ + "static/media/can.1d354e3d.svg";